export default __webpack_public_path__ + "static/media/S-031.269d38e9.png";